/**
 * Node modules
 */
import React from 'react';

export default React.memo(props => (
  <svg
    fill="currentColor"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>
      Menu
    </title>
    <line
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="48"
      x1="88"
      x2="424"
      y1="152"
      y2="152"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="48"
      x1="88"
      x2="424"
      y1="256"
      y2="256"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="48"
      x1="88"
      x2="424"
      y1="360"
      y2="360"
    />
  </svg>
));
